import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpsertRolePermissionRequest } from './types/upsert-role-permission-request.type';

/**
 * Assigns a permission to a role.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the role.
 * @param body - The permission grant, including the effective and expiration dates.
 * @returns OperationResult (no payload).
 */
export const upsertRolePermission = async (instance: KyInstance, uid: string, body: UpsertRolePermissionRequest) => {
  try {
    return await instance
      .post<OperationResult>(formatString(Uri.roles.permissions, uid), {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
